import NewsFeed from "./NewsFeed";

export default NewsFeed;